import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {FACTURA_EXPORTACION_TYPES} from '../../../../constants/factura-exportacion.types'
import {DocumentoRelacionadoFE} from '../../../../interfaces/factura-exportacion.interface'
import {esNormativaV2} from '../../../../utils/normativa.utils'
import {Pagination} from '../../../../components/Pagination'
import ModalEliminar from '../../../EmitirFactura/Components/GeneracionFactura/Modals/ModalEliminar'
import ModalDocumentoRelacionadoFEX from './ModalDocumentoRelacionadoFEX'
import {MAXIMO_DOCUMENTOS_RELACIONADOS, nombreTipoGeneracion} from './documentos-relacionados.utils'
import AbrirIcon from '../../../../media/felsv/down-arrow-svgrepo-com.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import DeleteIcon from '../../../../media/felsv/MinusDelete.svg'

export default function DocumentosRelacionadosFEX() {
  const dispatch = useDispatch()
  const {docsRelacionados} = useSelector((state: State) => state.facturaExportacion)
  const {datosEmisor} = useSelector((state: State) => state.catalogos)

  const [mostrarContenido, setMostrarContenido] = useState(false)
  const [documentoEdit, setDocumentoEdit] = useState<DocumentoRelacionadoFE | null>(null)
  const [documentoEliminar, setDocumentoEliminar] = useState<DocumentoRelacionadoFE | null>(null)
  const [mostrarModal, setMostrarModal] = useState(false)
  const [pagina, setPagina] = useState<Array<DocumentoRelacionadoFE>>([])

  if (!esNormativaV2(datosEmisor)) return null

  const guardarLista = (lista: Array<DocumentoRelacionadoFE>) =>
    dispatch({type: FACTURA_EXPORTACION_TYPES.FE_SET_DOCS_RELACIONADOS, payload: lista})

  const abrirAgregar = () => {
    setDocumentoEdit(null)
    setMostrarModal(true)
  }

  const abrirEditar = (documento: DocumentoRelacionadoFE) => {
    setDocumentoEdit(documento)
    setMostrarModal(true)
  }

  const guardarDocumento = (documento: DocumentoRelacionadoFE) => {
    if (documentoEdit) {
      guardarLista(
        docsRelacionados.map((item) => (item.id === documentoEdit.id ? {...documento} : item))
      )
    } else {
      guardarLista([
        ...docsRelacionados,
        {...documento, id: Math.floor(Math.random() * 900000) + 100000},
      ])
    }

    setMostrarModal(false)
    setDocumentoEdit(null)
  }

  const eliminarDocumento = () => {
    guardarLista(docsRelacionados.filter((item) => item.id !== documentoEliminar?.id))
    setDocumentoEliminar(null)
  }

  const alcanzoElMaximo = docsRelacionados.length >= MAXIMO_DOCUMENTOS_RELACIONADOS

  return (
    <div className='w-layout-cell'>
      <div style={{width: '100%', boxShadow: 'none'}} className='card'>
        <h3
          className='card-title l'
          onClick={() => setMostrarContenido(!mostrarContenido)}
          style={{cursor: 'pointer'}}
        >
          Documentos relacionados
          <img alt='Abrir' src={AbrirIcon} style={{marginLeft: '16px', width: '15px'}} />
        </h3>
        {mostrarContenido && (
          <div style={{overflowX: 'scroll'}}>
            <p className='m'>
              Registre los documentos que originan esta factura de exportación. Puede agregar hasta{' '}
              {MAXIMO_DOCUMENTOS_RELACIONADOS}; si no aplica ninguno, deje la lista vacía.
            </p>
            <div className='w-layout-hflex button-actions' style={{margin: '16px 0px'}}>
              <button
                type='button'
                className='m button w-inline-block'
                style={{maxWidth: '240px'}}
                onClick={abrirAgregar}
                disabled={alcanzoElMaximo}
              >
                <div>Agregar documento relacionado</div>
              </button>
            </div>
            {alcanzoElMaximo && (
              <p className='alert s'>
                Ya registró el máximo de {MAXIMO_DOCUMENTOS_RELACIONADOS} documentos relacionados
                que admite el esquema de Hacienda.
              </p>
            )}
            <div className='form-separator'></div>
            <table className='table-main-responsive responsive-table-main td-left'>
              <thead>
                <tr>
                  <td>Tipo de documento</td>
                  <td>Generación</td>
                  <td>Número de documento</td>
                  <td>Fecha de emisión</td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {pagina.map((documento) => (
                  <tr key={documento.id}>
                    <td data-label='Tipo de documento'>
                      {`${documento.tipoDocumento}${
                        documento.tipoDocumentoDescripcion
                          ? ` - ${documento.tipoDocumentoDescripcion}`
                          : ''
                      }`}
                    </td>
                    <td data-label='Generación'>
                      {nombreTipoGeneracion(documento.tipoGeneracion)}
                    </td>
                    <td data-label='Número de documento' style={{wordBreak: 'break-all'}}>
                      {documento.numeroDocumento}
                    </td>
                    <td data-label='Fecha de emisión'>{documento.fechaEmision}</td>
                    <td data-label='Acciones'>
                      <button type='button' onClick={() => abrirEditar(documento)}>
                        <img alt='Editar' src={EditIcon} />
                      </button>
                      <button type='button' onClick={() => setDocumentoEliminar(documento)}>
                        <img alt='Eliminar' src={DeleteIcon} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              data={docsRelacionados}
              state={(items: Array<any>) => setPagina(items)}
              items={5}
            />
            {mostrarModal && (
              <ModalDocumentoRelacionadoFEX
                documentoEdit={documentoEdit}
                onClicCerrar={() => {
                  setMostrarModal(false)
                  setDocumentoEdit(null)
                }}
                onClicGuardar={guardarDocumento}
              />
            )}
            {documentoEliminar && (
              <ModalEliminar
                eliminar={true}
                actionEliminar={eliminarDocumento}
                closeModalEliminar={() => setDocumentoEliminar(null)}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
